import React from 'react';
import styles from './UpsertModule.module.css';
import { moduleTemplateKeysDict } from '../../config';

export default function ModuleInfo({ moduleTemplate }) {
  const keys =
    moduleTemplate &&
    Object.keys(moduleTemplate).filter((key) => !key.includes('Id'));
  return (
    <div className={styles.moduleInfo}>
      <table>
        <tbody>
          {moduleTemplate &&
            keys.map((key) => {
              return (
                <tr key={key}>
                  <td>{moduleTemplateKeysDict[key]}</td>
                  <td>{moduleTemplate[key]}</td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
}
